// extracted by mini-css-extract-plugin
export default {"container":"Monitor_container__DU+iE","rows":"Monitor_rows__KjlFe","boxes":"Monitor_boxes__OCscI","attitude":"Monitor_attitude__bQ2Fz"};